/**
 * Used for derivatives that deliver into cash underlying.
 * tag: 974
 * @readonly
 * @enum {string} (String)
 */
export enum UnderlyingCashType {
  /** FIXED */
  FIXED = 'FIXED',
  /** DIFF */
  DIFF = 'DIFF',
}
